import { RadioGroupField, SubmitFormButton, useFormContext } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { BodyText } from '@calendly/ui/components/typography';
import { createPortal } from 'react-dom';
import { SettingsModalFooterActions } from 'features/settings_modal/footer_actions';
import { useSettingsModalLayoutOptional } from 'features/settings_modal/layout_context';
import { FormFooter } from '../styles';
const radioGroupCss = "r4eazct";
const PaymentsSettingsModalFooterActions = () => {
  const {
    submitForm,
    resetForm
  } = useFormContext();
  return <SettingsModalFooterActions onSave={submitForm} onCancel={resetForm} />;
};
export const FormContent = () => {
  const {
    handleReset
  } = useFormContext();
  const {
    showFooterHost,
    footerHost
  } = useSettingsModalLayoutOptional() ?? {};
  const options = [{
    label: I18n.t('publisher.organization_settings.payments.everyone.title'),
    description: <BodyText inline color="muted">
          {I18n.t('publisher.organization_settings.payments.everyone.subtitle')}
        </BodyText>,
    value: 'everyone'
  }, {
    label: I18n.t('publisher.organization_settings.payments.no_one.title'),
    description: <BodyText inline color="muted">
          {I18n.t('publisher.organization_settings.payments.no_one.subtitle')}
        </BodyText>,
    value: 'no_one'
  }];
  return <>
      <RadioGroupField name="paymentsAccess" options={options} className={radioGroupCss} />
      {showFooterHost ? footerHost != null && createPortal(<PaymentsSettingsModalFooterActions />, footerHost) : <FormFooter>
            <Button decoration="secondary-outline" onClick={handleReset}>
              {I18n.t('publisher.action.cancel')}
            </Button>
            <SubmitFormButton>
              {I18n.t('publisher.action.save')}
            </SubmitFormButton>
          </FormFooter>}
    </>;
};

require("./form_content.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./form_content.js");